
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Card, Button, OverlayTrigger, Tooltip, Row, Col, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import { FaThumbsUp, FaThumbsDown  } from "react-icons/fa";

// import Select from 'react-select';

const HODWaiverApproval = () => {

  const [fwPlanLimit, setFWPlanLimit] = useState('');
  const [fwUtilLimit, setFWUtilLimit] = useState('');
  const [fwAvailLimit, setFWAvailLimit] = useState('');
  const [selectedYear1, setSelectedYear1] = useState('');
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      irn: '',
      year1: '',
      section_id: '',
      gr_no: '',
      stud_name: '',
      fw_id: '',
      fw_desc: '',
      std_div: '',
      fw_remarks: '',
      waiver_amt: '',
    }
  ]);

  useEffect(() => {
    const fetchLists = async () => {
      try {

        retrieveAllocFW();

      } catch (err) {
        console.error("Data fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  const retrieveAllocFW = async () => {

    try {

      setChildRows([]);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);

      setSelectedYear1(year_result.data[0].year1);

      const result = await axios.get(`${BASE_URL}/api/get_hod_fw_appr`, {params : {p_year1: year_result.data[0].year1}});

      if (result.data.hodLimit) {
        setFWPlanLimit(result.data.hodLimit.plan_limit);
        setFWUtilLimit(result.data.hodLimit.util_limit);
        setFWAvailLimit(result.data.hodLimit.avail_limit);
      }

      if (result.data.feewaiverList) {
        setChildRows(result.data.feewaiverList);
      } else {
        //setChildRows([{ irn: '', year1: '', section_id: '', gr_no: '', stud_name: '', fw_id: '', fw_desc: '', std_div: '', }]);
        setChildRows([]);
      }

    } catch (error) {
      toast.error('Error in Approval. ' + error);
    }

  }

  const handleYearChange = (e) => {

//    const { name, value } = e.target;

    setSelectedYear1(e.target.value);

  };

  const handleApprove = async (index) => {

    const studentName = childRows[index]?.stud_name;
    const fwDesc = childRows[index]?.fw_desc;

    const irn = childRows[index]?.irn;
    const year1 = childRows[index]?.year1;
    const sectionId = childRows[index]?.section_id;
    const grNo = childRows[index]?.gr_no;
    const fwId = childRows[index]?.fw_id;
    const waiverAmt = Number(childRows[index]?.waiver_amt || 0);

    try {

      const validate_lmt = await axios.get(`${BASE_URL}/api/validate_hod_limit`, { params: { p_year1: year1, p_waiver_amt: waiverAmt } });

      //if (validate_lmt.data.length > 0) {
        if (validate_lmt.data.valid_flg === '0') {
          toast.error(`Available Limit : ` + formatAmtNoDec(fwAvailLimit) + `/-, is not sufficient to approve ` + formatAmtNoDec(waiverAmt));
          return;
        }
      //}

      const isConfirmed = window.confirm(`Approve the Fees Waiver, ${fwDesc}, for Student, ${studentName}`);

      if (!isConfirmed) return;

      const response = await axios.post(`${BASE_URL}/api/appr_rej_fw_alloc`,
        { params: { p_Status: 'APPR', p_Year1: year1, p_Section_Id: sectionId, p_GR_No: grNo, p_irn: irn, p_fw_Id: fwId, p_waiver_amt: waiverAmt } });

      if (response.data.message === '1') {
        setChildRows([]);
        toast.success('Fee Waiver Approved successfully.');
        retrieveAllocFW();
      } else {
        toast.error('Unable tp Approve Fee Waiver.');
      }

    } catch (error) {
      toast.error('Error in Approval. ' + error);
    }

  };

  const handleReject = async (index) => {

    const studentName = childRows[index]?.stud_name;
    const fwDesc = childRows[index]?.fw_desc;

    const isConfirmed = window.confirm(`Reject the Fees Waiver, ${fwDesc}, for Student, ${studentName}`  );

    if (!isConfirmed) return;

    const irn = childRows[index]?.irn;
    const year1 = childRows[index]?.year1;
    const sectionId = childRows[index]?.section_id;
    const grNo = childRows[index]?.gr_no;
    const fwId = childRows[index]?.fw_id;

    const response = await axios.post(`${BASE_URL}/api/appr_rej_fw_alloc`, 
      {params : {p_Status: 'REJ', p_Year1: year1, p_Section_Id: sectionId, p_GR_No: grNo, p_irn: irn, p_fw_Id:fwId, p_waiver_amt: '0' }});

    if (response.data.message === '1') {
      setChildRows([]);
      toast.error('Fee Waiver Rejected successfully.');
      retrieveAllocFW();
    }

  };

  const formatAmount = (amount) =>
    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatAmtNoDec = (amount) =>
    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  // const handleRefresh = () => {
  //   setChildRows([]);
  //   retrieveAllocFW();
  // };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        <Row>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}> Academic Year 
              </InputGroup.Text>
              <select className="form-select" name="selectedYear1" value={selectedYear1} onChange={handleYearChange}  >
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          {/* Planned Waiver Limit */}
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px", background: "#60A5FA" }}> <b>Planned Limit </b>
              </InputGroup.Text>

              <input type="text" inputMode="decimal" className="form-control"
                name="fwPlanLimit" value={formatAmount(fwPlanLimit)} disabled  style={{ textAlign: "right" }} />
            </InputGroup>
          </Col>

          {/* Utilized Waiver Limit */}
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ background: "#FBBF24" }}> <b>Utilized Limit</b>
              </InputGroup.Text>

              <input type="text" className="form-control" name="fwUtilLimit"
                value={formatAmount(fwUtilLimit)}  disabled style={{ textAlign: "right" }} />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text  style={{ background: "#4ADE80" }}> <b>Available Limit</b>
              </InputGroup.Text>

              <input type="text" className="form-control" name="fwAvailLimit"
                value={formatAmount(fwAvailLimit)}  disabled style={{ textAlign: "right" }} />
            </InputGroup>
          </Col>

        {/* <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap"> */}
          {/* <Col md={2}>

          <button type="button" className="btn btn-primary" style={{ width: "135px" }} onClick={handleRefresh} > Refresh
          </button>

        </Col> */}
        {/* </div> */}

        </Row>

      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '4%', textAlign: 'center' }}>#</th>
                <th style={{ width: '27%', textAlign: 'left' }}>Student Name</th>
                <th style={{ width: '9%', textAlign: 'left' }}>Std/Div</th>
                <th style={{ width: '18%', textAlign: 'left' }}>Allocated Fee Waiver</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Waiver Amt</th>
                <th style={{ width: '26%', textAlign: 'left' }}>Remarks</th>
                <th style={{ width: '5%', textAlign: 'center' }}></th>
                <th style={{ width: '5%', textAlign: 'center' }}></th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "4%", textAlign: 'center' }}>{index + 1}</td>
                  <td>{row.stud_name} </td>
                  <td>{row.std_div} </td>
                  <td> {row.fw_desc} </td>
                  <td style={{ textAlign: 'right' }}> {formatAmount(row.waiver_amt)} </td>
                  <td> {row.fw_remarks} </td>

                  <td style={{ textAlign: 'center' }}>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-approve-${index}`} >Approve</Tooltip>} >
                      <span className="d-inline-block">
                        <Button disabled={childRows.length === 0} variant="success" onClick={() => handleApprove(index)} >
                          <FaThumbsUp style={{ marginRight: "5px" }} /> </Button>
                        {/* Approve */}
                      </span>
                    </OverlayTrigger>
                  </td>

                  <td style={{ textAlign: 'center' }}>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-approve-${index}`} >Reject</Tooltip>}>
                      <span className="d-inline-block">
                        <Button disabled={childRows.length === 0} variant="danger" onClick={() => handleReject(index)} >
                          <FaThumbsDown style={{ marginRight: "5px" }} /> </Button>
                        {/* Reject */}
                      </span>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default HODWaiverApproval;
